let forceRefreshActive = false;

export const isForceRefreshActive = (): boolean => forceRefreshActive;

export async function withForceRefresh<T>(fn: () => Promise<T>): Promise<T> {
  forceRefreshActive = true;
  try {
    return await fn();
  } finally {
    forceRefreshActive = false;
  }
}
